import _ from "lodash";
import { useState, useEffect } from "react";
import { template as tmpl } from "./template";

const ConfirmOTP = ({
	payload = {},
	method,
	onSubmitConfirmOTP,
	expiredDate,
	onBack,
	loading,
	errors,
	onResendOTP,
}) => {
	const { user_data = {} } = payload;

	const [countDown, setCountDown] = useState(0);
	const [otp, setOtp] = useState("");

	useEffect(() => {
		if (expiredDate) {
			const countDownDate = new Date(expiredDate).getTime();
			const interval = setInterval(() => {
				setCountDown(countDownDate - new Date().getTime());
			}, 1000);

			return () => clearInterval(interval);
		}
	}, [expiredDate]);

	const onConfirmOTP = async () => {
		if (!otp || loading) return;
		onSubmitConfirmOTP(otp);
	};

	const handleChangeOtp = (otp) => {
		setOtp(otp);
	};

	const initProps = {
		userInfo: user_data,
		method: method,
		errors: errors,
		payload: payload,
		otp: otp,
		setOtp: setOtp,
		countDown,
		handleChangeOtp: handleChangeOtp,
		sendCodeAgain: onResendOTP,
		onConfirmOTP,
		onBack,
		loading,
	};
	return tmpl && tmpl({ ...initProps });
};

export default ConfirmOTP;
